import React from 'react';
import { Box, ButtonBase, Dialog, IconButton, Typography } from '@material-ui/core';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { baseCassConfirm } from '../baseCss';

export default function TransferConfirmation({ closePop, open, allData, confirmHandle }) {
  const baseClasses = baseCassConfirm();

  const confirmClick = () => {
    if (typeof confirmHandle === 'function') {
      confirmHandle();
    }
  };

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={baseClasses.root}>
        <div className={baseClasses.header} style={{ padding: '2.187rem 0 1.562rem' }}>
          <Typography className={baseClasses.headerTitle}>{i18n.t('BEDSTATUS_TRANSFER_CONFIRMATION')} </Typography>
          <IconButton id="bed_cancelconfirmation_close_btn" className={baseClasses.closeIcon} onClick={closePop}>
            <CloseIcon />
          </IconButton>
        </div>
        <Typography className={baseClasses.areYouSureYouWou}>{i18n.t('BEDSTATUS_SURE_TRANSFER_OUT')}</Typography>
        <Box display="flex" justifyContent="center" style={{ margin: '7rem 0 2.375rem 0' }}>
          <ButtonBase
            id="bed_cancelconfirmation_cancel"
            className={baseClasses.cancelBtn}
            style={{ marginRight: '1.313rem' }}
            onClick={closePop}
          >
            {i18n.t('BEDSTATUS_CANCEL')}
          </ButtonBase>
          <ButtonBase id="bed_cancelconfirmation_confirm" className={baseClasses.configBtn} onClick={confirmClick}>
            {i18n.t('BEDSTATUS_CONFIRM')}
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}
